import {ModelBase} from '../../../models/abstract/model-base';

export class State {
    list: ModelBase[]       = [];
    itemId: string          = null;
    item: ModelBase         = null;
    originalItem: ModelBase = null;
}
